import './Footer.css';
import GlobalConstants from "../../config/GlobalConstants";

export default function Footer(props) {
    return (
            <div style={{backgroundColor: props.backgroundColor != null ? props.backgroundColor : "#ffffff"}}>
                <div className="siteFooter" style={{backgroundColor: props.footerColor != null && props.footerColor}}>
                    <div className="siteFooter-container">

                        <div className="siteFooter-content">
                            <div id="footer2spalten">
                                <div id="footerspalte1" style={{float: "left"}}>
                                </div>

                                <div id="footerspalte2">
                                    <div id="nl_footer">
                                        <div className="siteFooter-title">Hol dir noch mehr Informationen!</div>
                                        <br/>
                                        <a href="https://manage.kmail-lists.com/subscriptions/subscribe?a=WE3JYn&g=Ut4PMh">
                                            <button className="formSubmit button" type="button">
                                                <span className="button-inner">Zum Newsletter</span>
                                            </button>
                                        </a>
                                    </div>

                                </div>
                            </div>

                            <nav className="siteFooter-navigation" role="navigation">
                                <div className="siteFooter-brand">
                                    <img src="//tiger.media/cdn/shop/files/TM_tigermedia-Logo_RGB_W_1c685fc0-8a08-42d0-8686-72ee1aa52c4f.png?v=1715159781&width=1686" alt={"tiger brand logo"} width={168}/>
                                </div>

                                <div className="siteFooter-siteLinks">
                                    <a className="siteFooter-siteLink " href="https://tiger.media/policies/legal-notice"
                                       title="Impressum">
                                        Impressum </a>
                                    <a className="siteFooter-siteLink " href="https://tiger.media/policies/terms-of-service" title="AGB">
                                        AGB </a>
                                    <a className="siteFooter-siteLink " href="https://tiger.media/policies/privacy-policy"
                                       title="Datenschutz">
                                        Datenschutz </a>
                                    <a className="siteFooter-siteLink " href="https://helpcenter.tiger.media/hc/de" title="Hilfe">
                                        Hilfe </a>
                                    <a className="siteFooter-siteLink " href="https://tiger.media/pages/unternehmen"
                                       title="Unternehmen">
                                        Unternehmen </a>
                                    <a className="siteFooter-siteLink " href="https://tiger.media/pages/stellenanzeigen"
                                       title="Stellenanzeigen">
                                        Stellenanzeigen </a>
                                    <a className="siteFooter-siteLink " href="https://tiger.media/policies/contact-information"
                                       title="Kontakt">
                                        Kontakt </a>
                                    <a className="siteFooter-siteLink " href={GlobalConstants.URL_CANCEL_CONTRACTS}
                                       title="Vertrag kündigen">
                                        Vertrag kündigen </a>
                                </div>
                            </nav>

                            <div className="siteFooter-social">
                                <p>
                                    Folge uns auf <a href="https://www.instagram.com/tiger.media/" target="_blank" rel="noreferrer">Instagram</a> oder <a href="https://www.facebook.com/tiger.media.deutschland/" target="_blank" rel="noreferrer">Facebook</a>.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    );
}